export default __webpack_public_path__ + "static/media/logo.212352a3.png";